// extracted by mini-css-extract-plugin
module.exports = {"logos":"logos-module--logos--3xMDt","item":"logos-module--item--1BXC6"};